import { StatusBar } from 'expo-status-bar';
import React from 'react';
import ENV from 'app/utils/ENV'
import { StyleSheet, View, ScrollView, TouchableOpacity, ActivityIndicator, 
  TextInput, UIManager, Platform, RefreshControl, FlatList, } from 'react-native';
import Animated from 'react-native-reanimated'
const { multiply, sub } = Animated;
import Text from 'app/components/Text'
import * as RootNavigation from 'app/utils/RootNavigation.js';
import ValueListItem from 'app/components/ValueListItem'
import apiActions from 'app/utils/apiActions'
import valueActions from 'app/utils/valueActions'
import storageActions from 'app/utils/storageActions'
import textHelpers from 'app/utils/textHelpers'
import { styleSheet, colors, sizes, WIDTH } from 'app/utils/styleSheet'
import valueHelpers from 'app/utils/valueHelpers'

import DraggableFlatList from "react-native-draggable-flatlist";
import QuickComposer from 'app/components/QuickComposer'
import Autocomplete from 'app/components/Autocomplete'
import { Ionicons, Feather, } from '@expo/vector-icons';

import { TouchableOpacity as RNGHTouchableOpacity, PinchGestureHandler } from "react-native-gesture-handler";
const isAndroid = Platform.OS === "android";
if (isAndroid && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}
const PlatformTouchable = isAndroid ? TouchableOpacity : TouchableOpacity;


export default class List extends React.Component { 
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      refreshing: false,
      parentQuery: '',
      lastScrollAt: Date.now(),
    }

    this.onViewableItemsChanged = ({viewableItems}) => {
      // console.log(viewableItems)
      
      // let { lastScrollAt } = this.state

      let level = viewableItems[0]?.item?.level
      if(!!level || level == 0){
        console.log('scrolled to level:', level)
        // console.log('toplevel:', this.props.topLevel)
        // console.log('props.level:', this.props.level)
        this.props.onChangeLevel(level)
      }

      // // Get the first viewable item
      // const firstViewableItem = viewableItems[0]?.key;

      // // Get its index into the items
      // const index = this.state.items.findIndex(item => item.key === firstViewableItem);

      // // If the index is a multiple of the number of items displayable on the screen
      // // by checking for a reminder on the modulo operation
      // if ((index % NB_ITEMS_SCREEN) === 0) {

      //   // get page
      //   const currentPage = index / NB_ITEMS_SCREEN;
      //   if (currentPage !== this.state.currentPage) {
      //     // Do something and update currentPage in this.state
      //   }
      // }
    }
  }

  static defaultProps = {
    values: [],
    ids: [],
    zoom: 1.0,
  }

  itemRefs = new Map();

  refresh = async () => {
    // await this.fetch()
    // this.setState({refreshing: false})
  }

  onZoomEvent = (e) => {
    let scale = e?.nativeEvent?.scale
    if(!!scale){
      // console.log(scale)
      this.setState({zoom: scale})
    }
    // console.log('zoom event:', e)
  }
  
  onZoomStateChange = (e) => {
    // console.log('zoom state change: ', e)
  }

  render(){
    let { loading, level, topLevel, zoom, } = this.props
    // console.log(level, topLevel)
    let { fetching } = this.state
    return (
      <View style={{ flex: 1 }}>


      {/*
      <PinchGestureHandler
        onGestureEvent={this.onZoomEvent}
        onHandlerStateChange={this.onZoomStateChange}
      >
        <View style={{width: 300, height: 300, backgroundColor: 'blue'}}>
          <Text>{zoom}</Text>
        </View>
      </PinchGestureHandler>
      */}
        {/*<View style={styles.inputRow}>
          <QuickComposer
            ref={ref => this.composer = ref}
            fetching={fetching || loading}
            values={allValues}
            onSubmit={this.props.onSubmit}
            // onPress={close}
            // pointerEvents={!!openDirection ? 'box-only' : 'auto'}
          />
        </View>*/}
        <FlatList
          ref={ref => this.paginationRef = ref}
          data={this.pages()}
          style={{ flex: 1 }}
          renderItem={({ item }) => {
            return this.renderPage(item)
          }}
          pagingEnabled
          horizontal
          getItemLayout={(data, index) => (
            // {length: ITEM_HEIGHT, offset: ITEM_HEIGHT * index, index}
            {length: Math.min(500, WIDTH), offset: Math.min(500,WIDTH) * index, index}
          )}
          initialScrollIndex={topLevel - level}
          onViewableItemsChanged={this.onViewableItemsChanged}
          showsHorizontalScrollIndicator={true}
          onScrollEndDrag={() => {
            console.log('scroll end!!!')
          }}
          onScroll={() => {
            // this.setState({lastScrollAt: Date.now()})
          }}
        />
      </View>
    )
  }

  scrollToLevel = level => {
    let { topLevel } = this.props
    if(this.paginationRef){
      let index = topLevel - level
      // alert(`${index} ${level}/${topLevel}`)
      // alert(index)
      // if(!!index || index == 0)
        this.paginationRef.scrollToIndex({index})
    }
  }

  pages = () => {
    let { values, loading, levelIds, topLevel, } = this.props
    let { fetching, } = this.state

    let pages = Object.keys(levelIds).map(level => {
      let levelValues = values.filter(v => levelIds[level].includes(v.id)).map(v => ({
        ...v,
        key: v.id,
      }))
      return {
        values: levelValues,
        level,
      }
    })
    
    // let pages = new Array(topLevel+1).fill({})
    // pages = pages.map((page,i) => {
    //   let level = i
    //   // let lvlVals = allValues.filter(v => v.level == level)
    //   let lvlVals = values.filter(v => v.level == level)
    //     .map(v => ({...v, key: v.id}))
    //   // order values by ids array
    //   // let order = {}
    //   // ids.forEach((id, i) => order[id] = i)
    //   // values.sort((a, b) => order[a.id] - order[b.id])
    //   return {
    //     values: lvlVals,
    //     level,
    //     // ids,
    //   }
    // })
    pages.reverse()
    // console.log(topLevel, 'pages: ', pages)
    return pages
  }

  renderPage(page){
    let { values, level, } = page
    let { loading, onRefresh, refreshing, } = this.props
    let { fetching, } = this.state

    return (
      <View style={styles.pageWrapper} key={`level-${level}`}>
        <PinchGestureHandler
          simultaniousHandlers
          onGestureEvent={this.onZoomEvent}
          onHandlerStateChange={this.onZoomStateChange}
        >
        <FlatList
        // <DraggableFlatList
          simultaniousHandlers
          refreshControl={ // this interferes with draggable ordering
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} 
              colors={[colors.foreground]} tintColor={colors.foreground}
              progressBackgroundColor={colors.fill}
            />
          }
          activationDistance={15}
          data={values}
          extraData={this.state.values}
          ListFooterComponent={<View style={{height: sizes.base}}/>}
          // ListHeaderComponent={(
          //   this.renderItem({item: {key: 'composer'}}, 
          //     this.renderComposer,
          //     this.renderComposerUnderlayLeft,
          //     this.renderComposerUnderlayRight,
          //   )
          // }
          // ListHeaderComponent={(
          //   <View style={styles.inputRow}>
          //     <QuickComposer
          //       ref={ref => this.composer = ref}
          //       fetching={fetching || loading}
          //       values={allValues}
          //       onSubmit={this.props.onSubmit}
          //       // onPress={close}
          //       // pointerEvents={!!openDirection ? 'box-only' : 'auto'}
          //     />
          //   </View>
          // )}
          keyExtractor={(item, index) => `draggable-item-${item.key}`}
          onDragEnd={async ({ data }) => {
            if(this.props.onSortIds){
              let values = data
              let ids = values.map(v => v.id)
              this.props.onSortIds(ids)
            }
          }}
          renderItem={this.renderItem}
        />
        </PinchGestureHandler>
        {ENV.WEB && this.props.onSortIds && this.renderSortingCol(values)}
      </View>
    )
  }

  renderItem = (
    { item, index, drag, isActive }, 
    renderOverlay=null, renderUnderlayLeft=null, renderUnderlayRight=null
  ) => {
    let { onCreate, onComplete, onCancel, onUpdate, todoIds, focusIds, hiddenIds, noDrag, } = this.props
    let { zoom } = this.state
    let value = item
    // let value = item.item
    return (
      <View style={{marginTop: sizes.base}} key={index} simultaniousHandlers>
        <ValueListItem
          simultaniousHandlers
          value={value}
          // pointerEvents={!!openDirection ? 'box-only' : 'auto'}
          // onPress={!!openDirection ? () => close() : undefined}
          onUpdate={!!onUpdate ? onUpdate : undefined}
          // move to parent comp
          onSubmit={() => onComplete ? onComplete(value) : null}
          onCancel={() => onCancel ? onCancel(value) : null}
          loading={value.loading}
          onLongPress={noDrag ? undefined : drag}
          // style={item.item.isActive ? {borderWidth: 2, borderColor: colors.trim} : null}
          style={item.isActive ? {borderWidth: 2, borderColor: colors.trim} : null}
          // scale={zoom}
          scale={this.props.scale}
          // onPressRight={openLeft}
          // onPressLeft={openRight}
          hideButtons={this.props.hideButtons}
        />
      </View>
    );
  }

  renderSortingCol = (values) => {
    return (
      <View style={{
        width: 50,
        flexDirection: 'column',
        paddingTop: 140,
      }}>
        {values.map((value,i) => (
          <View key={i} style={{
            height: 122,
            paddingVertical: 10,
            justifyContent: 'space-around',
            alignItems: 'center',
            // borderWidth: 1, borderColor: 'white',
          }}>
            <TouchableOpacity onPress={async () => {
              if(i == 0) return
              values.splice(i, 1)
              values.splice(i-1, 0, value)
              let ids = values.map(v => v.id)
              this.props.onSortIds(ids)
            }}>
              <Text style={{fontSize: 16}}>^</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={async () => {
              if(i == values.length-1) return
              values.splice(i, 1)
              values.splice(i+1, 0, value)
              let ids = values.map(v => v.id)
              this.props.onSortIds(ids)
            }}>
              <Text style={{fontSize: 12}}>v</Text>
            </TouchableOpacity>
          </View>
        ))}
      </View>
    )
  }

  viewParents = value => {
    alert('needs review')
    return
    // let ids = value.parent_ids
    // RootNavigation.push('List', {ids})
  }
  
  viewChildren = value => {
    alert('needs review')
    return
    // let ids = value.child_ids
    // RootNavigation.push('List', {ids})
  }

}

const styles = StyleSheet.create({
  pageWrapper: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start', 
    // alignSelf: 'center',
    // width: '100%',
    // maxWidth: 500,
    width: Math.min(500, WIDTH),
    alignSelf: 'center',
    // alignItems: 'stretch',
    // overflow: 'hidden',
    // backgroundColor: colors.empty,
    paddingBottom: sizes.large,
  },
  inputRow: {
    zIndex: 2,
    flex: 1,
    // flexGrow: 0,
    borderWidth: 3, borderColor: 'red',
    // marginBottom: sizes.base,
  },
  list: {
    // flex: 1,
    // borderWidth: 3, borderColor: 'green',
    // position: 'relative',
    // left: -(sizes.giant * levelsDeep),
  },

  row: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "space-around",
    // padding: 15
  },
  underlayRight: {
    flex: 1,
    // backgroundColor: "teal",
    justifyContent: "flex-start"
  },
  underlayLeft: {
    flex: 1,
    // backgroundColor: "tomato",
    justifyContent: "flex-end"
  },

  bigInput: {
    color: colors.foreground,
    backgroundColor: 'transparent',
    // marginBottom: 0,
    // lineHeight: sizes.itemHeight,
    textAlignVertical: 'center',
    height: sizes.itemHeight,
  },
})